<template>
 <div v-if="corpus.length" class="detection-corpus-collapse">
    <pt-sub-title title="检测项知识库" ></pt-sub-title>
    <div v-for="(corpusItem, i) in corpus" :key="i">
        <el-collapse  class="collapseBox">
          <el-collapse-item :name="i">
            <template slot="title">
              {{corpusItem.corpusName || corpusItem.chineseName}}
            </template>
            <div v-for="(level1, index) in corpusItem.contents" :key="index">
              <el-collapse>
                <el-collapse-item :title="level1.header" :name="index">
                  <div v-html="replaceEnter(level1.description)"></div>
                  <el-collapse  v-for="(level2, index_sec) in level1.contents" :key="index_sec">
                    <el-collapse-item :title="level2.header +'（'+ (level2.hasIcon == true ? '有' : '无')+'图标）'" :name="index+'_'+index_sec">
                      <div v-html="replaceEnter(level2.description)"></div>
                      <el-collapse v-for="(level3, index_third) in level2.contents" :key="index_third">
                        <el-collapse-item :title="level3.header +'（'+ (level3.hasIcon == true ? '有' : '无')+'图标）'" :name="index+'_'+index_sec+'_'+index_third">
                          <div v-html="replaceEnter(level3.description)"></div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-collapse-item>
                  </el-collapse>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-button v-if="showEdit" type="text" @click="goEdit(corpusItem.id,corpusItem)" class="editText">编辑</el-button>
      </div>
 </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    id (val) {
      this.getDetectionCorpus()
    }
  },
  data () {
    return {
      corpus: []
    }
  },
  methods: {
    replaceEnter (data) {
      // var reg = new RegExp('\n', 'g')
      // return data.replace(reg, '<br>')
      return data.replace(/[\r\n]/g, '<br>')
    },
    getDetectionCorpus () {
      this.$store.dispatch('getDetectionCorpusByid', this.id).then((response) => {
        console.log('getDetectionCorpus', response.data)
        if (response.data.length) {
          this.corpus = response.data
        }
      }).catch((error) => {
        this.$messgae.warning(error)
        console.log(error)
      })
    },
    goEdit (id, value) {
      // 将详情数据传递给更新页面
      this.$router.push({ name: 'detection-corpus-update', params: { id: id, value: value } })
    }
  },
  created () {
    if (this.id) {
      this.getDetectionCorpus()
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.detection-corpus-collapse{
  .collapseBox{
    width: 80%;
    display: inline-block;
	}
	.editText{
    vertical-align: top;
    margin-left: 10px;
	}
  .el-collapse{
    margin-bottom: 20px;
    margin-left: 20px;
    padding-left: 20px;
    border: 0.01rem solid #ebeef5;
	}
}
</style>
